import SignInCallback from './SignInCallback.component';

export default SignInCallback;
